import React from 'react';

import useCountryConfigurationShim from '@rover/shared/js/hooks/useCountryConfigurationShim';
import useCurrentUserShim from '@rover/shared/js/hooks/useCurrentUserShim';
import useLocalizedBrandCountryServicesByServiceType from '@rover/shared/js/hooks/useLocalizedBrandCountryServicesByServiceType';

import ServiceOverview from './ServiceOverview/ServiceOverview';

const ServicesForEveryPet = (): JSX.Element => {
  const { navigation } = useCountryConfigurationShim();
  const servicesByType = useLocalizedBrandCountryServicesByServiceType();
  const { isAuthenticated } = useCurrentUserShim();

  const defaultActiveTabId = isAuthenticated ? 'other' : 'overnight';

  return (
    <ServiceOverview
      servicesByType={servicesByType}
      hasPetInsurance={navigation?.hasPetInsurance}
      defaultActiveTabId={defaultActiveTabId}
    />
  );
};

export default ServicesForEveryPet;
